import React from 'react';

import PropTypes from 'prop-types';

import FilledButton from 'components/application/buttons/FilledButton';
import TextButton from 'components/application/buttons/TextButton';
import ModalBox from 'components/application/ModalBox';

export default function DestroyProjectDocumentModal({
  isDeletePdfMutationLoading,
  onClose,
  onDestroySubmit,
}) {
  return (
    <ModalBox
      customFooter={
        <div className='modalbox__footer-actions modalbox__footer-actions--right'>
          <TextButton
            className='tw-mr-12'
            color='blue'
            disabled={isDeletePdfMutationLoading}
            onClick={onClose}
            size='md'
          >
            Cancel
          </TextButton>
          <FilledButton
            color='red'
            disabled={isDeletePdfMutationLoading}
            onClick={onDestroySubmit}
          >
            {isDeletePdfMutationLoading ? '...removing' : 'Yes, delete PDF'}
          </FilledButton>
        </div>
      }
      isOpen={true}
      mode='flexible'
      onClose={onClose}
    >
      <div className='tw-p-6'>
        <h2 className='tw-m-0 tw-pb-6 tw-text-l tw-font-semibold tw-text-grey-900'>
          Delete this PDF attachment?
        </h2>
        <p className='tw-m-0 tw-p-0 tw-text-m tw-font-normal tw-text-grey-700'>
          Are you sure you want to delete this PDF?
        </p>
      </div>
    </ModalBox>
  );
}

DestroyProjectDocumentModal.propTypes = {
  isDeletePdfMutationLoading: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onDestroySubmit: PropTypes.func.isRequired,
};
